<template>
  <div>
    <a-form :form="form" @submit="saveColumnData">
      <a-form-item
        label="账号"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <span>{{ adminDetail.account }}</span>
      </a-form-item>
      <a-form-item
        label="关联角色"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          v-decorator="[
            'role_id',
            {
              initialValue: adminDetail.role_id,
              rules: [{ required: true, message: '请选择所属角色' }]
            }
          ]"
          placeholder="请选择所属角色">
          <a-select-option v-for="item in roleDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="联系人名称"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'nickname',
            {
              initialValue: adminDetail.nickname,
              rules: [{ required: true, message: '请输入联系人名称' }]
            }
          ]"
          placeholder="请输入联系人名称"/>
      </a-form-item>
      <a-form-item
        label="联系人电话"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'phone',
            {
              initialValue: adminDetail.phone,
              rules: [{ required: true, message: '请输入联系人电话' }]
            }
          ]"
          placeholder="请输入联系人电话"/>
      </a-form-item>
      <a-form-item
        label="密码"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          type="password"
          v-decorator="[
            'password'
          ]"
          placeholder="留空则不修改密码"/>
      </a-form-item>
      <a-form-item
        :required="true"
        label="状态"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-radio-group v-model="adminDetail.status">
          <a-radio-button v-if="status.id !== ''" v-for="status in statusDict" :value="status.id" :key="status.id">{{ status.name }}</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item
        label="备注"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-textarea
          v-decorator="[
            'remark',
            {
              initialValue: adminDetail.remark,
              rules: [{ required: true, message: '请输入备注' }]
            }
          ]"
          :rows="6"
          placeholder="请输入备注"/>
      </a-form-item>
      <a-form-item :wrapperCol="{span: 12, offset: 9}">
        <a-button style="margin-right:20px" html-type="submit" type="primary">保存</a-button>
        <a-button @click="onClose">取消</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
import { pre, postUpdateAdmin } from '@/api/admin'
import { passwordEncryption } from '@/utils/util'
import _ from 'lodash'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    adminId: {
      type: Number,
      default: 0
    },
    adminDetail: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      form: this.$form.createForm(this),
      // 编辑抽屉弹窗form-item标题样式
      labelCol: { lg: { span: 6 }, sm: { span: 5 } },
      // 编辑抽屉弹窗form-item组件样式
      wrapperCol: { lg: { span: 15 }, sm: { span: 19 } },
      // 抽屉加载
      loading: true,
      // 添加角色数据
      adminData: {
        admin_id: '',
        role_id: '',
        account: '',
        password: '',
        nickname: '',
        realname: '',
        phone: '',
        status: '',
        remark: ''
      },
      roleDict: [],
      statusDict: []
    }
  },
  methods: {
    handelPre () {
      pre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.roleDict = _.get(res, 'values.roleDict', [])
          this.statusDict = _.get(res, 'values.statusDict', [])
        }
      })
    },
    // 抽屉关闭事件
    onClose () {
      this.$emit('hide')
    },
    // 抽屉保存按钮
    saveColumnData (e) {
      e.preventDefault()
      this.form.validateFields((err, fieldsValue) => {
        if (!err) {
          this.adminData.admin_id = this.adminId
          this.adminData.account = this.adminDetail.account
          this.adminData.role_id = fieldsValue['role_id']
          this.adminData.nickname = fieldsValue['nickname']
          this.adminData.realname = fieldsValue['realname']
          this.adminData.phone = fieldsValue['phone']
          this.adminData.status = this.adminDetail.status
          if (fieldsValue['password'] !== '') {
            this.adminData.password = passwordEncryption(fieldsValue['password'])
          }
          this.adminData.remark = fieldsValue['remark']
          postUpdateAdmin(this.adminData).then(res => {
            if (_.get(res, 'code') === 200) {
              this.$message.success('保存成功')
              this.$emit('finish')
            }
          })
        }
      })
    }
  },
  created () {
    this.handelPre()
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  }
}
</script>
